import { Stack, Typography } from "@mui/material";
import useOrderStore from "../../../stores/useOrderStore";
import { useEffect } from "react";
import index from "../../../api/auth/orders/orderRefunds";
import WushCard from "../../layout/WushCard";
import { format } from "date-fns";

export default function OrderRefunds({ order }) {
  const { orderRefunds, setOrderRefunds } = useOrderStore();

  useEffect(() => {
    index(order.id, (response) => {
      setOrderRefunds(response);
    });
  }, []);

  if(orderRefunds.length === 0) return null;

  return (
    <WushCard>
      <Stack p={2}>
        <Stack mb={2} spacing={1}>
          {
            orderRefunds.map((orderRefund) => (
              <Stack key={orderRefund.id}>
                <Typography variant="body1">
                  <b>${orderRefund.amount_dollars}</b> - {orderRefund.reason}
                </Typography>
                <Typography variant="caption">
                  <i>{orderRefund.created_at && format(new Date(orderRefund.created_at), 'MM/dd/yyyy @ hh:mm aa')}</i>
                </Typography>
              </Stack>
            ))
          }
        </Stack>
        <Stack>
          <Typography variant="h6">
            Total refunded: ${orderRefunds.reduce((acc, orderRefund) => acc + parseFloat(orderRefund.amount_dollars), 0)}
          </Typography>
        </Stack>
      </Stack>
    </WushCard>
  );
}